import {gql} from "@irati/utils/gql"

const query = gql`
  query loginRefresh($expiredToken: String!) {
    loginRefresh(expiredToken: $expiredToken) {
      accessToken
    }
  }
`

export const toString = query.loc.source.body

export default query
